import React from "react";
import Header from "../header/Header";
import Navigation from "../navigation/Navigation";
import "./asideBar.css";
import { useToggleContext } from "../ToggleContext";

const AsideBar = () => {
  const {
    isToggle,
    setIsToggle,
    navActive,
    setNavActive,
    toggleQuickLinkMenu,
    setToggleQuickLinkMenu,
    hideOverlay,
  } = useToggleContext();

  return (
    <>
      <Header
        isToggle={isToggle}
        navActive={navActive}
        setnavActive={setNavActive}
        setIsToggle={setIsToggle}
        toggleQuickLinkMenu={toggleQuickLinkMenu}
        setToggleQuickLinkMenu={setToggleQuickLinkMenu}
      />
      <Navigation
        navActive={navActive}
        isToggle={isToggle}
        setIsToggle={setIsToggle}
      />
      {(isToggle || toggleQuickLinkMenu) && (
        <div
          className="m-aside-left-overlay"
          onClick={hideOverlay}
        ></div>
      )}
    </>
  );
};

export default AsideBar;
